import React from 'react';
import { Expense } from '../types';
import { getExpenses } from '../api/expense';


export default function useExpenses(begin: string, end: string): Expense[] {
  const [expenses, setExpenses] = React.useState<Expense[]>([]);
  
  React.useEffect(() => {
    if (!begin || !end) {
      return;
    }

    getExpenses(begin, end).then(setExpenses);
  }, [begin, end]);

  return expenses;
}
